<template>
  <div
    ref="wrap"
    class="self-service-btn-text"
    :class="{ 'is-marquee': needMarquee }"
  >
    <span
      ref="textEl"
      class="self-service-btn-text-inner"
      :style="marqueeStyle"
    >{{ text }}</span>
  </div>
</template>

<script>
/**
 * 自助服务按钮文案：未溢出居中；溢出则自动滚到尾、停顿后从头重播
 */
export default {
  name: 'SelfServiceBtnText',
  props: {
    text: {
      type: String,
      default: ''
    },
    /** 整段动画时长（秒），含起止停顿 */
    duration: {
      type: Number,
      default: 6
    }
  },
  data() {
    return {
      needMarquee: false,
      scrollDistance: 0
    };
  },
  computed: {
    marqueeStyle() {
      if (!this.needMarquee || this.scrollDistance <= 0) {
        return null;
      }
      return {
        '--scroll-x': `-${this.scrollDistance}px`,
        animationDuration: `${this.duration}s`
      };
    }
  },
  watch: {
    text() {
      this.checkOverflow();
    }
  },
  mounted() {
    this.checkOverflow();
    window.addEventListener('resize', this.checkOverflow);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkOverflow);
  },
  methods: {
    checkOverflow() {
      this.needMarquee = false;
      this.scrollDistance = 0;
      this.$nextTick(() => {
        const wrap = this.$refs.wrap;
        const textEl = this.$refs.textEl;
        if (!wrap || !textEl) return;
        const distance = textEl.scrollWidth - wrap.clientWidth;
        if (distance > 1) {
          this.scrollDistance = distance;
          this.needMarquee = true;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.self-service-btn-text {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;

  &.is-marquee {
    text-align: start;

    .self-service-btn-text-inner {
      display: inline-block;
      will-change: transform;
      animation-name: self-service-btn-text-scroll;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
    }
  }

  &:not(.is-marquee) {
    text-align: center;

    .self-service-btn-text-inner {
      display: inline-block;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: middle;
    }
  }
}

/* 起停 → 滚到尾 → 停顿 → 瞬间回到头 */
@keyframes self-service-btn-text-scroll {
  0%,
  8% {
    transform: translateX(0);
  }
  55%,
  100% {
    transform: translateX(var(--scroll-x, 0));
  }
}
</style>
